import { render } from "./SetOrModifyPWD.vue?vue&type=template&id=da19a0a4&ts=true"
import script from "./SetOrModifyPWD.vue?vue&type=script&lang=ts"
export * from "./SetOrModifyPWD.vue?vue&type=script&lang=ts"

import "./SetOrModifyPWD.vue?vue&type=style&index=0&id=da19a0a4&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__